import { AuthClient } from "./internal/AuthClient";

/** Validated token + Me state; deliberately separate from the last rendered user cache. */
export const authenticatedSession = {
  getSnapshot: AuthClient.getSessionUser,
  subscribe: AuthClient.subscribeSession,
  isUnauthenticated: AuthClient.isUnauthenticated,
};
